import { useRecoilState } from 'recoil';
import { loadingState } from '../states/loadingState';
import styled from 'styled-components';
import { ReactComponent as MacLogo } from '../assets/mac-logo.svg';
import { ReactComponent as WindowsLogo } from '../assets/windows-logo.svg';
import { ReactComponent as LinuxLogo } from '../assets/linux-logo.svg';
import { ReactComponent as AppleLogo } from '../assets/apple-logo.svg';
import { ReactComponent as AndroidLogo } from '../assets/android-logo.svg';
import { ReactComponent as BannerCloseBtn } from '../assets/btn-banner-close.svg';
import useIsMobile from '../hooks/useIsMobile';
import { useLocation } from 'react-router-dom';
import { modalState } from '../states/modalState';
import { useEffect, useState } from 'react';
import BannerTest from '../../public/bannerTest.png';

const HIDE_BANNER_PATHS = ['download', 'payment', 'redirect', 'policy'];

const Banner = () => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const [, setModalState] = useRecoilState(modalState);
  const [showBanner, setShowBanner] = useState<boolean>(false);

  useEffect(() => {
    const hasBannerFlag = sessionStorage.getItem('show-banner') === 'true';
    const isHideBannerPath = HIDE_BANNER_PATHS.some((path) =>
      location.pathname.includes(path)
    );

    const _showBanner = hasBannerFlag && !isHideBannerPath;
    setShowBanner(_showBanner);
  }, [location]);

  const closeBanner = () => {
    setShowBanner(false);
    sessionStorage.removeItem('show-banner');
  };

  //@TODO: 실제 배너 작업
  const openBannerModal = () => {
    setModalState({
      isOpen: true,
      component: (
        <div
          style={{
            width: 930,
            height: 519,
            backgroundImage: `url(${BannerTest})`,
            backgroundRepeat: 'none',
            backgroundSize: 'contain',
          }}
        ></div>
      ),
    });
  };

  if (!showBanner || isMobile) {
    return;
  }

  return (
    <Container>
      <span>PC앱을 설치하여 더 편리하게 사용하세요!</span>
      <div
        style={{
          display: 'flex',
          gap: '10px',
          marginLeft: 13,
          marginRight: 16,
        }}
      >
        <MacLogo />
        <WindowsLogo />
        <LinuxLogo />
        <AppleLogo />
        <AndroidLogo />
      </div>
      <BannerButton onClick={openBannerModal}>다운로드</BannerButton>
      <div
        style={{
          cursor: 'pointer',
          top: 7,
          right: 6,
          position: 'absolute',
        }}
        onClick={closeBanner}
      >
        <BannerCloseBtn />
      </div>
    </Container>
  );
};

export default Banner;

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
  background-color: #3359ff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: 400;
`;

const BannerButton = styled.button`
  width: 70px;
  height: 24px;
  border-radius: 30px;
  font-weight: 600;
  font-size: 11px;
  color: #3359ff;
`;
